const Reviews = () => {

    var elements = document.querySelectorAll(".woocommerce-product-rating");

    if (elements) {
        // dodawanie listenera dla każdego elementu
        elements.forEach(function (element) {
            element.addEventListener('click', function () {
                // wyszukiwanie elementu z id "tab-title-reviews"
                var tabTitleReviews = document.querySelector("#tab-title-reviews a");

                // sprawdzanie, czy znaleziono element z id "tab-title-reviews"
                if (tabTitleReviews) {
                    tabTitleReviews.click();

                    // przewijanie do elementu z id "tab-title-reviews a"
                    window.scrollTo({
                        top: tabTitleReviews.getBoundingClientRect().top + window.pageYOffset - 30,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }

}

export default Reviews;